import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { useModalConfirm } from "@ryde/redux";
import { ConfirmResult } from "@ryde/shared";

import { ColorIconButton } from "../../../controls";
import { CsvCellTemplate } from "../../templates-table/csv-list.template";
import { IUserRoleItemForm } from "./table-user-roles.models";
import { UserRoleOtherCompanyWarning } from "./user-role-other-company-warning";

export const UserRoleDisplay: FC<Partial<IUserRoleItemForm>> = ({
  removeHandler,
  index,
  onEdit,
  value,
}) => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const message = t(`general.ITEM_ARCHIVE_MESSAGE`);

  const onArchiveClickEvent = useEvent(async (): Promise<void> => {
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message,
    });

    if (confirmationResult === ConfirmResult.OK) {
      removeHandler?.(index || 0);
    }
  });

  return (
    <div className="userRoles-item display-mode">
      <div className="userRoles-item__data">
        <div className="userRoles-item__data--row">
          <label className="userRoles-item__role-label">
            {t("role.single")}

            {!!value?.roleId && (
              <UserRoleOtherCompanyWarning roleId={value.roleId} />
            )}
          </label>

          {value?.roleId ? (
            <CsvCellTemplate
              customClassName="userRoles-cell"
              name={"role"}
              value={[value?.roleId]}
              formAttributes={{ dropItemsSource: "role" }}
            />
          ) : (
            <i>{t("general.ANY")}</i>
          )}
        </div>

        <div className="userRoles-item__data--row">
          <label>{t("site.plural")}</label>
          {value?.siteIds?.length ? (
            <CsvCellTemplate
              customClassName="userRoles-cell"
              name={"sites"}
              value={value?.siteIds}
              formAttributes={{ dropItemsSource: "site" }}
            />
          ) : (
            <i>{t("general.ANY")}</i>
          )}
        </div>

        <div className="userRoles-item__data--row">
          <label>{t("supplier.plural")}</label>
          {value?.supplierIds?.length ? (
            <CsvCellTemplate
              customClassName="userRoles-cell"
              name={"suppliers"}
              value={value?.supplierIds}
              formAttributes={{ dropItemsSource: "supplier" }}
            />
          ) : (
            <i>{t("general.ANY")}</i>
          )}
        </div>

        <div className="userRoles-item__data--row">
          <label>{t("unit.plural")}</label>
          {value?.unitIds?.length ? (
            <CsvCellTemplate
              customClassName="userRoles-cell"
              name={"units"}
              value={value?.unitIds}
              formAttributes={{ dropItemsSource: "unit" }}
            />
          ) : (
            <i>{t("general.ANY")}</i>
          )}
        </div>

        <div className="userRoles-item__data--row">
          <label>{t("rideType.plural")}</label>
          {value?.rideTypeIds?.length ? (
            <CsvCellTemplate
              name={"rideTypes"}
              value={value?.rideTypeIds}
              formAttributes={{ dropItemsSource: "rideType" }}
            />
          ) : (
            <i>{t("general.ANY")}</i>
          )}
        </div>
      </div>
      <div className="userRoles-item__buttons">
        <ColorIconButton
          iconType="EDIT"
          edge="end"
          aria-label="edit"
          className="edit-button"
          onClick={() => {
            onEdit?.();
          }}
        />
        <ColorIconButton
          iconType="DELETE"
          edge="end"
          aria-label="delete"
          onClick={() => onArchiveClickEvent()}
        />
      </div>
    </div>
  );
};
